import { Pagination } from 'antd';
import { usePaymentInvoicesTableStore } from 'store/paymentInvoicesTable';
import { usePaymentInvoicesTableFiltersStore } from 'store/paymentInvoicesTableFilters';
import type { TComponent } from 'utils/types/component';

export const CustomPagination: TComponent = () => {
    const params = usePaymentInvoicesTableFiltersStore('reportsParams');
    const totalElements = usePaymentInvoicesTableStore('totalReportsElements');

    const setParams = usePaymentInvoicesTableFiltersStore('setReportsParams');
    const getPaymentReports = usePaymentInvoicesTableStore('getPaymentReports');

    const page = params.page + 1;

    const handleChangePage = (currentPage: number, pageSize: number) => {
        const enhancePage = currentPage - 1;

        const newParams = { ...params, page: enhancePage, size: pageSize };

        setParams(newParams);
        getPaymentReports(newParams);
    };

    return (
        <Pagination
            showSizeChanger
            current={page}
            total={totalElements}
            onChange={handleChangePage}
        />
    );
};
